import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col } from 'antd';
import { useNavigate } from "react-router-dom";
import Header from '../common/header'
import CreateProfileModal from "./modals/create-profile";
import DeleteProfileModal from "./modals/delete-profile";
import { useAppContext, APP_ACTIONS } from "../../context/appContext";
import api from "../common/img/api.png"
import fetchProfiles from '../common/helpers/fetch-profiles';
import fetchBots from "../common/helpers/fetch-bots";
import createProfile from "../common/helpers/create-profile";
import deleteProfile from "../common/helpers/delete-profile";
import moment from "moment";

const { Option } = Select;
const { TabPane } = Tabs;


const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }
const tableRowStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }

const Profile = ({ hasAuth }) => {
    const {
        state: { profiles, bots },
        dispatch,
    } = useAppContext();

    // let navigate = useNavigate();
    const [displayCreateProfile, setDisplayCreateProfile] = useState(false);
    const [displayDeleteProfile, setDisplayDeleteProfile] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState({});

    const handleProfileCreate = (profile) => {
        createProfile(profile).then((res) => {
            if (res.error) {
                message.error(res.error);
            }
            fetchProfiles().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_PROFILES,
                    payload: res,
                })
            })
        })
    }

    const handleProfileDelete = (id) => {
        deleteProfile(id).then(() => {
            fetchProfiles().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_PROFILES,
                    payload: res,
                })

                fetchBots().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })
                })

            })
        })
    }
    const findUsage = (id) => {
        let usageCount = 0
        bots.forEach(bot => {
            if (bot.host.id === id) {
                if (bot.active) {
                    usageCount++;
                }
            }
        })

        return usageCount;
    }

    useEffect(() => {
        fetchProfiles().then(res => {
            if (res.message) return;
            dispatch({
                type: APP_ACTIONS.SET_PROFILES,
                payload: res,
            })
        })
    }, [hasAuth])
    return (
        <>
            {displayCreateProfile && <CreateProfileModal displayCreateProfile={displayCreateProfile} setDisplayCreateProfile={setDisplayCreateProfile} onProfileCreate={handleProfileCreate} />}
            {displayDeleteProfile && <DeleteProfileModal displayDeleteProfile={displayDeleteProfile} setDisplayDeleteProfile={setDisplayDeleteProfile} selectedProfile={selectedProfile} handleProfileDelete={handleProfileDelete} />}


            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="89.909" height="60.607" viewBox="0 0 89.909 60.607">
                            <path id="Path_5499" data-name="Path 5499" d="M305.026,216.029a10.25,10.25,0,0,0-6.77,2.577H296.63V199.052a3.031,3.031,0,0,0-3.031-3.031H275.056a3.027,3.027,0,0,0-3.031,3.031v5.92a3.038,3.038,0,0,0,1.063,2.31,4.158,4.158,0,0,1,1.514,3.2,4.232,4.232,0,1,1-8.463,0,4.16,4.16,0,0,1,1.511-3.2,3.039,3.039,0,0,0,1.066-2.31v-5.92a3.031,3.031,0,0,0-3.031-3.031H247.244a3.033,3.033,0,0,0-3.141,3.031v19.556h-1.631a10.294,10.294,0,1,0,0,15.435H244.1V253.6a3.03,3.03,0,0,0,3.031,3.031h18.541a3.027,3.027,0,0,0,3.031-3.031v-5.92a3.043,3.043,0,0,0-1.063-2.31,4.158,4.158,0,0,1-1.514-3.2,4.232,4.232,0,1,1,8.463,0,4.16,4.16,0,0,1-1.511,3.2,3.039,3.039,0,0,0-1.066,2.31v5.92a3.031,3.031,0,0,0,3.031,3.031H293.6a3.027,3.027,0,0,0,3.031-3.031l0-19.556h1.631a10.282,10.282,0,1,0,6.773-18.011Zm0,14.526a4.173,4.173,0,0,1-3.2-1.511,3.03,3.03,0,0,0-2.306-1.066H293.6a3.03,3.03,0,0,0-3.031,3.031l0,19.556H278.08v-1.631a10.294,10.294,0,1,0-15.434,0v1.631h-12.48V231.011a3.027,3.027,0,0,0-3.031-3.031h-5.92a3.041,3.041,0,0,0-2.31,1.061,4.15,4.15,0,0,1-3.2,1.515,4.232,4.232,0,1,1,0-8.463,4.16,4.16,0,0,1,3.2,1.511,3.039,3.039,0,0,0,2.31,1.066h5.92a3.031,3.031,0,0,0,3.031-3.031V202.083h12.489v1.631a10.294,10.294,0,1,0,15.435,0v-1.631h12.48l0,19.554a3.027,3.027,0,0,0,3.031,3.031h5.924a3.034,3.034,0,0,0,2.306-1.063,4.171,4.171,0,0,1,3.2-1.514,4.232,4.232,0,0,1,0,8.463Z" transform="translate(-225.408 -196.019)" fill="#fff" opacity="0.5" />
                        </svg>
                        <div>
                            <div style={{ color: "white", fontSize: 17, cursor: "default" }}>Exchange API profiles</div>
                            <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>Create an exchange API profile by connecting it through API keys. Use profiles with your bot so to execute strategies and more</div>
                            <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>To start click <span style={{ textDecoration: "underline" }}>'NEW'</span> </div>
                        </div>
                    </div>
                    <div>
                        <Button onClick={() => { setDisplayCreateProfile(true); }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">NEW</Button>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                        <div style={{ maxHeight: 800, overflowY: "auto" }}>
                            <table style={{ width: "100%", }}>
                                <tr>
                                    <th style={tableHeaderStyle} >NAME</th>
                                    <th style={tableHeaderStyle} >API KEY</th>
                                    <th style={tableHeaderStyle} >API SECRET</th>
                                    <th style={tableHeaderStyle} >TOKEN</th>
                                    <th style={tableHeaderStyle} >PASSWORD</th>
                                    <th style={tableHeaderStyle} >DATE ADDED</th>
                                    <th style={tableHeaderStyle} >USAGE</th>
                                    <th style={tableHeaderStyle} >DELETE</th>
                                </tr>
                                {profiles.map(profile =>
                                    <tr>
                                        <td style={tableRowStyle}>
                                            <div>{profile.name}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            {profile?.api_key && profile?.api_key?.substring(0, 7) + '********************' || '-'}
                                        </td>
                                        <td style={tableRowStyle}>
                                            {profile?.api_secret && profile?.api_secret?.substring(0, 10) + '***************************' || '-'}
                                        </td>
                                        <td style={tableRowStyle}>
                                            {profile?.token && profile?.token?.substring(0, 20) + '*****************' || '-'}
                                        </td>
                                        <td style={tableRowStyle}>
                                            {profile?.password && profile?.password?.substring(0, 20) + '*************' || '-'}
                                        </td>
                                        <td style={tableRowStyle}>{moment(profile.createdAt).format('MMMM Do YYYY') || '-'}</td>
                                        <td style={tableRowStyle}>{findUsage(profile.id)}</td>
                                        <td onClick={() => { setSelectedProfile(profile); setDisplayDeleteProfile(true); }} style={tableRowStyle}><span style={{ textDecoration: "underline", cursor: "pointer" }}>(DELETE)</span></td>
                                    </tr>)}

                            </table>
                        </div>
                        {profiles.length === 0 && <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                            <img src={api} style={{ marginBottom: 10 }} />
                            <div style={{ color: "white" }} >THERE ARE NO API PROFILES HERE.</div>
                            <div style={{ color: "white" }} >START BY CLICKING NEW BELOW.</div>
                            <Button onClick={() => { setDisplayCreateProfile(true); }} style={{ backgroundColor: "#161616", color: "white", width: 150, height: 50, marginTop: 10 }} type="default">NEW</Button>
                        </div>}
                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

export default Profile;